import React from 'react';
import { TableCell, Tooltip } from '@material-ui/core';
import moment from 'moment';
import numeral from 'numeral';
import AccountTypeAvatar from './AccountTypeAvatar';
import LinkIcon from '@material-ui/icons/Link';

export const CellItem = ({
  items,
  fld,
  hideZero = false,
  indent,
  wrapText = false,
  width = 'auto',
  maxWidth = 'auto',
  toolTip = '',
  handleCheckRecBal = () => {},
  ...rest
}) => {
  let align_value = 'left';

  if (fld.align) align_value = fld.align;

  if (fld.hideZero) hideZero = fld.hideZero;

  if (fld.fld === 'acc_type') {
    return (
      <TableCell
        align="center"
        style={{
          width: width,
          minWidth: width,
          maxWidth: maxWidth
        }}
      >
        <AccountTypeAvatar type={items?.acc?.ixAccType ?? 0} />
      </TableCell>
    );
  }

  if (fld.format == 'padded4') {
    return (
      <TableCell
        align={align_value}
        style={{
          paddingLeft: indent ? '3em' : '',
          whiteSpace: wrapText ? 'nowrap' : 'normal',
          width: width,
          minWidth: width,
          maxWidth: maxWidth
        }}
      >
        {String(items[fld.fld]).padStart(4, '0')}
      </TableCell>
    );
  }
  if (fld.format == 'padded6') {
    return (
      <TableCell
        align={align_value}
        style={{
          paddingLeft: indent ? '3em' : '',
          whiteSpace: wrapText ? 'nowrap' : 'normal',
          width: width,
          minWidth: width,
          maxWidth: maxWidth
        }}
      >
        {String(items[fld.fld]).padStart(6, '0')}
      </TableCell>
    );
  }
  if (fld.date) {
    if (!items[fld.fld]) {
      return (
        <TableCell
          style={{
            paddingLeft: indent ? '3em' : '',
            whiteSpace: wrapText ? 'nowrap' : 'normal',
            width: width,
            minWidth: width,
            maxWidth: maxWidth
          }}
        />
      );
    }
    if (items[fld.fld] == 0 && hideZero) {
      return (
        <TableCell
          style={{
            paddingLeft: indent ? '3em' : '',
            whiteSpace: wrapText ? 'nowrap' : 'normal',
            width: width,
            minWidth: width,
            maxWidth: maxWidth
          }}
        />
      );
    }
    return (
      <TableCell
        align="left"
        style={{
          paddingLeft: indent ? '3em' : '',
          whiteSpace: wrapText ? 'nowrap' : 'normal',
          width: width,
          minWidth: width,
          maxWidth: maxWidth
        }}
      >
        {moment(items[fld.fld]).format(fld.date)}
      </TableCell>
    );
  }
  if (fld.numeral) {
    if (items[fld.fld] == 0 && hideZero) {
      return <TableCell />;
    }
    return (
      <TableCell
        align="right"
        style={{
          paddingLeft: indent ? '3em' : '',
          whiteSpace: wrapText ? 'nowrap' : 'normal',
          width: width,
          minWidth: width,
          maxWidth: maxWidth
        }}
      >
        {numeral(items[fld.fld]).format(fld.numeral)}
      </TableCell>
    );
  } else {
    return (
      <TableCell
        align={align_value}
        style={{
          paddingLeft: indent ? '3em' : '',
          whiteSpace: wrapText ? 'nowrap' : 'normal',
          width: width,
          minWidth: width,
          maxWidth: maxWidth
        }}
      >
        {toolTip !== '' ? (
          <Tooltip title={items?.[toolTip]}>
            <span> {items[fld.fld]}</span>
          </Tooltip>
        ) : (
          <span>
            {items[fld.fld]}
            {fld.fld === 'sAccTitle' && !!items?.ixReqBalSrc && (
              <LinkIcon
                onClick={() => handleCheckRecBal(items)}
                fontSize="small"
                color="primary"
                style={{ marginLeft: 4, verticalAlign: 'middle' }}
              />
            )}
          </span>
        )}
      </TableCell>
    );
  }
};
export const CellItemTotal = ({ items, fld, hideZero = false, ...rest }) => {
  if (fld.total) {
    if ((items?.[fld.fld] ?? 0) == 0 && hideZero) {
      return <TableCell />;
    }
    return (
      <TableCell align="right">
        <b>{numeral(items[fld.fld]).format(fld.numeral)}</b>
      </TableCell>
    );
  } else if (fld.totalCaption) {
    return (
      <TableCell align="right">
        <b>{fld.totalCaption}</b>
      </TableCell>
    );
  } else {
    return <TableCell />;
  }
};
